export const SUBSCRIPTION_REGISTRATION_CHANNEL_HOME_ONE = 'home-one'
